import React from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import CurrencyFormat from "react-currency-format";

const InputField = ({
  control,
  name,
  label,
  type,
  placeholder,
  rules,
  externalError = null,
  onChangeCallback = () => {},
  isCurrency = false, // Add a flag to check if it's a currency input
  isPercentages = false,
  ...otherProps
}) => (
  <div className="text-start">
    {label && <Form.Label>{label}</Form.Label>}
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        if (isCurrency) {
          return (
            <CurrencyFormat
              value={value || ""}
              thousandSeparator=","
              decimalScale={2}
              fixedDecimalScale
              onValueChange={({ floatValue }) => {
                onChange(floatValue);
                onChangeCallback(floatValue);
              }}
              decimalSeparator="."
              prefix="$ "
              customInput={TextField}
              placeholder={placeholder}
              error={!!error || !!externalError}
              helperText={error?.message || externalError}
              fullWidth
              size="small"
              variant="outlined"
              autoComplete="off"
              sx={{
                "& .MuiOutlinedInput-root.Mui-disabled": {
                  "& fieldset": {
                    borderColor: "#434343", // Border color for disabled
                  },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#898989", // Adjust text color for disabled
                },
              }}
              {...otherProps}
            />
          );
        }
        if (isPercentages) {
          return (
            <CurrencyFormat
              value={value || ""}
              decimalScale={2}
              fixedDecimalScale
              onValueChange={({ floatValue }) => {
                onChange(floatValue);
                onChangeCallback(floatValue);
              }}
              decimalSeparator="."
              customInput={TextField}
              placeholder={placeholder}
              error={!!error || !!externalError}
              helperText={error?.message || externalError}
              fullWidth
              suffix="%"
              size="small"
              variant="outlined"
              autoComplete="off"
              sx={{
                "& .MuiOutlinedInput-root.Mui-disabled": {
                  "& fieldset": {
                    borderColor: "#434343", // Border color for disabled
                  },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#898989", // Adjust text color for disabled
                },
              }}
              {...otherProps}
            />
          );
        }

        return (
          <TextField
            id={`${name}-input`} // Use a stable id
            size="small"
            type={type}
            placeholder={placeholder}
            value={value || ""}
            onChange={(event) => {
              const { value } = event.target; // Extract value from event
              onChange(value); // Update the form value
              onChangeCallback(value); // Trigger the custom callback
            }}
            error={!!error || !!externalError}
            helperText={error?.message || externalError}
            variant="outlined"
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root.Mui-disabled": {
                "& fieldset": {
                  borderColor: "#434343", // Border color for disabled
                },
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#898989", // Adjust text color for disabled
              },
            }}
            fullWidth
            {...otherProps}
          />
        );
      }}
    />
  </div>
);

export default InputField;
